import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, Box, Link, Button } from "@mui/material";
import safeLogger from "../utils/safeLogger";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

const PaymentStatus = () => {
  const { payment_id } = useParams();
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      try {
        const response = await fetch(
          `https://codefort.onrender.com/api/payment_status/${payment_id}`
        );
        const data = await response.json();

        if (response.ok) {
          setPaymentStatus(data);
        } else {
          setPaymentStatus({
            status: "error",
            message: data.error.message || "Erro desconhecido.",
          });
        }
      } catch (error) {
        safeLogger.error("Erro ao buscar status do pagamento:", error.message);
        setPaymentStatus({
          status: "error",
          message: "Erro ao processar o pagamento.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentStatus();
  }, [payment_id]);

  if (loading) {
    return <div>Carregando...</div>;
  }

  const renderContent = () => {
    if (!paymentStatus) {
      return <Typography>Erro ao buscar status do pagamento.</Typography>;
    }

    switch (paymentStatus.status) {
      case "approved":
        return (
          <>
            <CheckCircleOutlineIcon style={{ fontSize: 80, color: "green" }} />
            <Typography variant="h4" gutterBottom>
              Pagamento Aprovado
            </Typography>
            <Typography>
              <p>
                Seu pagamento foi aprovado com sucesso! Agradecemos pela sua
                confiança em nossos serviços.
              </p>
              <p>
                Estamos processando os dados da sua compra e preparando as
                informações necessárias para disponibilizar o seu cadastro. Este
                processo garante que tudo esteja devidamente configurado para
                que você possa começar a utilizar nossos serviços sem
                complicações.
              </p>
              <p>
                Em breve, você receberá um e-mail com as instruções detalhadas
                para realizar o registro de sua conta. Fique atento à sua caixa
                de entrada (e também à pasta de spam) para não perder nenhuma
                informação importante.
              </p>
              <p>
                Caso tenha dúvidas ou precise de suporte, nossa equipe está
                disponível para ajudar. Entre em contato pelo nosso canal de
                atendimento em{" "}
                <a href="mailto:suporte@empresa.com">suporte@codefort.com.br</a>.
              </p>
            </Typography>
          </>
        );
      case "rejected":
        return (
          <>
            <HighlightOffIcon style={{ fontSize: 80, color: "red" }} />
            <Typography variant="h4" gutterBottom>
              Pagamento Recusado
            </Typography>
            <Typography>
              Pagamento recusado. Por favor, entre em contato com sua operadora
              de cartão ou tente outro método de pagamento.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href="https://codefort.onrender.com" // Substituir com init_point
              style={{ marginTop: "20px" }}
            >
              Tentar Novamente
            </Button>
          </>
        );
      case "pending":
        return (
          <>
            <HourglassEmptyIcon style={{ fontSize: 80, color: "orange" }} />
            <Typography variant="h4" gutterBottom>
              Pagamento em Análise
            </Typography>
            <Typography>
              Seu pagamento está em análise. Isso pode levar até 30 minutos. Por
              favor, aguarde.
            </Typography>
          </>
        );
      default:
        return (
          <Typography>
            Erro: {paymentStatus.message || "Erro ao processar o pagamento."}
          </Typography>
        );
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      padding="20px"
      textAlign="center"
    >
      {renderContent()}
      <Box marginTop="auto" padding="20px 0">
        <Typography variant="body2" color="textSecondary">
          © 2025 CodeGuardian. Todos os direitos reservados.
        </Typography>
        <Link href="/privacy-policy" underline="hover">
          Política de Privacidade
        </Link>
      </Box>
    </Box>
  );
};

export default PaymentStatus;
